













import Component from "vue-class-component";
import Vue from "vue";
import { VApp } from "vuetify/lib";
import { castComponent } from "@/lib/helpers";

Vue.component("VApp", castComponent(VApp));

@Component({ name: "PageNotFound" })
export default class PageNotFound extends Vue {}
